module.exports = "<div class=c-content ng-class=\"{'c-content-limit-width':limitWidth, 'c-content-center':center}\"> <div ng-transclude></div> </div> ";